/* StarWays 2.0 — minimale header: logo links, login/avatar rechts */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { StarWaysLogo } from "./Brand";
import { useAuth } from "../context/AuthContext";

export const SwHeader = ({ onOpenAuth }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.add("sw-shell");
    return () => document.body.classList.remove("sw-shell");
  }, []);

  const initials = user?.name
    ? user.name.split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase()
    : "";

  return (
    <header
      className="w-full"
      style={{
        height: 64,
        background: "var(--sw-white)",
        borderBottom: "1px solid var(--sw-line)",
        position: "sticky",
        top: 0,
        zIndex: 40,
      }}
    >
      <div className="sw-container h-full flex items-center justify-between">
        <Link to="/" aria-label="Naar home" data-testid="sw-header-logo" className="flex items-center">
          <StarWaysLogo size={22} animate />
        </Link>

        <div className="flex items-center gap-1 sm:gap-4">
        <nav aria-label="Hoofdmenu" className="hidden sm:flex items-center gap-1">
          <Link to="/tarieven" className="sw-navlink" data-testid="sw-nav-tarieven">Tarieven</Link>
          <Link to="/veelgestelde-vragen" className="sw-navlink" data-testid="sw-nav-faq">Vragen</Link>
          <Link to="/voor-bedrijven" className="sw-navlink" data-testid="sw-nav-zakelijk">Zakelijk</Link>
        </nav>
        {!user ? (
          <button
            type="button"
            data-testid="sw-header-login"
            onClick={() => (onOpenAuth ? onOpenAuth() : navigate("/?stap=5"))}
            className="sw-btn sw-btn--ghost"
            style={{ minHeight: 40, padding: "0 16px", fontSize: 14, borderRadius: 999 }}
          >
            Inloggen
          </button>
        ) : (
          <div className="relative">
            <button
              type="button"
              data-testid="sw-header-avatar"
              onClick={() => setMenuOpen((v) => !v)}
              aria-haspopup="menu"
              aria-expanded={menuOpen}
              style={{
                width: 40, height: 40, borderRadius: 999,
                background: "var(--sw-mist)", color: "var(--sw-ink)",
                border: "1px solid var(--sw-line)",
                fontFamily: "'Bricolage Grotesque', sans-serif",
                fontWeight: 700, fontSize: 14, cursor: "pointer",
              }}
            >
              {initials || "·"}
            </button>
            {menuOpen && (
              <>
                <div
                  onClick={() => setMenuOpen(false)}
                  style={{ position: "fixed", inset: 0, zIndex: 20 }}
                />
                <div
                  role="menu"
                  data-testid="sw-header-menu"
                  style={{
                    position: "absolute", right: 0, top: 48, minWidth: 200,
                    background: "var(--sw-white)",
                    border: "1px solid var(--sw-line)",
                    borderRadius: 16,
                    boxShadow: "0 8px 24px rgba(18,36,29,0.08)",
                    overflow: "hidden",
                    zIndex: 30,
                  }}
                >
                  <MenuItem onClick={() => { setMenuOpen(false); navigate("/dashboard"); }} testid="menu-trips">
                    Mijn ritten
                  </MenuItem>
                  {user.role === "admin" && (
                    <MenuItem onClick={() => { setMenuOpen(false); navigate("/admin"); }} testid="menu-admin">
                      Admin
                    </MenuItem>
                  )}
                  <MenuItem onClick={() => { setMenuOpen(false); logout(); navigate("/"); }} testid="menu-logout">
                    Uitloggen
                  </MenuItem>
                </div>
              </>
            )}
          </div>
        )}
        </div>
      </div>
    </header>
  );
};

const MenuItem = ({ children, onClick, testid }) => (
  <button
    type="button"
    role="menuitem"
    onClick={onClick}
    data-testid={testid}
    style={{
      display: "block", width: "100%", textAlign: "left",
      padding: "12px 16px", background: "transparent", border: 0,
      fontFamily: "'Instrument Sans', sans-serif", fontSize: 14,
      color: "var(--sw-ink)", cursor: "pointer",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.background = "var(--sw-mist)")}
    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
  >
    {children}
  </button>
);

export default SwHeader;
